// Hard coded query -> url mappings
import { MarketCodes } from '@prisjakt/web-app-config/types/market';

const mappings = new Map<MarketCodes, Map<string, string>>();
mappings.set(
  'se',
  new Map([
    ['playstation 5', '/produkt.php?p=5113846'],
    ['iphone 12', '/c/mobiltelefoner?102214=36524&brand=142'],
    ['ps5', '/produkt.php?p=5113846'],
    ['iphone 11', '/c/mobiltelefoner?102214=34053&brand=142'],
    ['nintendo switch', '/c/spelkonsoler?102636=34315'],
    ['rtx 3060', '/c/grafikkort?532=36433%7C36256'],
    ['rtx 3080', '/c/grafikkort?532=36254'],
    ['ipad', '/c/surfplattor?brand=142'],
    ['rtx 3070', '/c/grafikkort?532=36253'],
    ['airpods', '/c/horlurar?1932=34086&brand=142'],
    ['iphone', '/c/mobiltelefoner?brand=142'],
    ['apple airpods', '/c/horlurar?1932=34086&brand=142'],
    ['xbox series x', '/produkt.php?p=5147004'],
    [
      'apple iphone xs max 64',
      '/c/mobiltelefoner?102214=33844&brand=142&q_name=Apple%2520iPhone%2520XS%2520Max',
    ],
    ['iphone 12 pro', '/c/mobiltelefoner?102214=36524&brand=142'],
    ['iphone 12 mini', '/c/mobiltelefoner?102214=36524&brand=142'],
    ['apple watch', '/c/smartwatches?brand=142'],
    ['iphone se', '/c/mobiltelefoner?102214=33841&brand=142'],
    ['iphone 11 pro', '/c/mobiltelefoner?102214=34053&brand=142'],
    ['rtx 3060 ti', '/c/grafikkort?103551=36436&532=36433'],
    ['geforce rtx 3080', '/c/grafikkort?103551=36436&532=36254'],
    ['geforce rtx 3070', '/c/grafikkort?103551=36436&532=36253'],
    ['iphone 12 pro max', '/c/mobiltelefoner?102214=36524&brand=142'],
    ['samsung galaxy s20', '/c/mobiltelefoner?102214=34054&brand=8'],
    ['3060 ti', '/c/grafikkort?532=36433'],
    ['iphone xr', '/c/mobiltelefoner?102214=33843&brand=142'],
    ['3060', '/c/grafikkort?532=36433%7C36256'],
    ['3080', '/c/grafikkort?532=36254'],
    ['3070', '/c/grafikkort?532=36253'],
    ['rtx 2060', '/c/grafikkort?532=32050%7C32421'],
    ['apple tv', '/c/mediaspelare?brand=142'],
    ['samsung galaxy s21', '/c/mobiltelefoner?102214=36669&brand=8'],
    ['ipad air', '/c/surfplattor?brand=142'],
    ['playstation', '/c/spelkonsoler?102636=34321%7C34322%7C34320'],
    ['rtx 3090', '/c/grafikkort?532=36255'],
    ['oculus quest 2', '/c/vr-glasogon?brand=43181&r_197=2020-2021'],
    ['samsung galaxy', '/c/mobiltelefoner?brand=8'],
    ['airpods pro', '/produkt.php?p=5209794'],
    ['apple iphone 12', '/c/mobiltelefoner?102214=36524&brand=142'],
    ['apple watch series 6', '/c/smartwatches?brand=142&q_name=series%25206'],
    ['geforce rtx 3060 ti', '/c/grafikkort?532=36433'],
    ['iphone x', '/c/mobiltelefoner?102214=33842&brand=142'],
    ['geforce rtx 3060', '/c/grafikkort?532=36433%7C36256'],
    [
      'samsung galaxy s21 ultra',
      '/c/mobiltelefoner?102214=36669&brand=8&q_name=ultra',
    ],
    ['apple watch se', '/c/smartwatches?brand=142&q_name=watch%2520se'],
    ['chromecast', '/c/mediaspelare?brand=11752'],
    ['ps4', '/produkt.php?p=3709489'],
    ['apple iphone 11', '/c/mobiltelefoner?102214=34053&brand=142'],
    ['lg cx', '/c/tv?brand=13'],
    ['macbook air', '/c/laptops-barbara-datorer?brand=142&q_name=air'],
    ['philips hue', '/c/ljuskallor?35756=36653&brand=12'],
    ['macbook pro', '/c/laptops-barbara-datorer?brand=142&q_name=pro'],
    ['iphone xs', '/c/mobiltelefoner?102214=33844&brand=142'],
    ['ssd', '/c/solid-state-diskar-ssd'],
    ['iphone 8', '/c/mobiltelefoner?102214=33840&brand=142'],
    ['samsung galaxy s10', ''],
    ['playstation 5 ps5', '/produkt.php?p=5113846'],
    ['sonos', '/c/hemmabiosystem?brand=2149'],
    ['macbook', '/c/laptops-barbara-datorer?brand=142'],
    ['switch', '/produkt.php?p=5162571'],
    ['apple iphone 12 pro', '/c/mobiltelefoner?102214=36524&brand=142'],
    ['gtx 1660 super', '/c/grafikkort?103551=36436&532=32763'],
    ['apple tv 4k', '/c/mediaspelare?brand=142'],
    ['moccamaster', '/c/kaffebryggare?brand=2249'],
    ['xbox', '/c/spelkonsoler?102636=34314%7C36329%7C34312'],
    ['gtx 1660', '/c/grafikkort?103551=36436&532=32119'],
    ['apple iphone se', '/c/mobiltelefoner?102214=33841&brand=142'],
    ['ipad pro', '/c/surfplattor?brand=142'],
    [
      'iphone 11 pro max',
      '/c/mobiltelefoner?102214=34053&brand=142&q_name=pro%2520max',
    ],
    ['samsung galaxy s20 fe', '/c/mobiltelefoner?102214=34054&brand=8'],
    ['samsung', '/c/mobiltelefoner?brand=8'],
    ['s21', '/c/mobiltelefoner?102214=36669&brand=8'],
    ['playstation 4', '/produkt.php?p=3709489'],
    ['xiaomi', ''],
    ['5600x', '/produkt.php?p=5588360'],
    ['geforce rtx 3090', '/c/grafikkort?103551=36436&532=36255'],
    ['dyson v11', '/c/dammsugare?brand=2595&q_name=v11'],
    ['tv', '/c/tv'],
    ['dyson', '/c/dammsugare?brand=2595'],
    ['samsung s21', '/c/mobiltelefoner?102214=36669&brand=8'],
    ['sodastream', '/c/kolsyremaskiner?brand=2254'],
    ['3090', '/c/grafikkort?103551=36436&532=36255'],
    ['rtx', '/c/grafikkort?532=GeForce+%5B3000+series%5D'],
    ['rtx 2070', '/c/grafikkort?103551=36436&532=31783%7C32422'],
    ['huawei p30 pro', '/c/mobiltelefoner?102214=33852&brand=2445'],
    ['roborock', '/c/robotdammsugare?brand=58966'],
    ['airfryer', ''],
    ['samsung s20', '/c/mobiltelefoner?102214=34054&brand=8'],
    ['1660 super', '/c/grafikkort?103551=36436&532=32763'],
    ['airpods 2nd generation', '/c/horlurar?b_4676=1&brand=142'],
    ['samsung qled', '/c/tv?7243=10113&brand=8&q_name=qled'],
    ['iphone 7', '/c/mobiltelefoner?102214=33839&brand=142'],
    ['yale doorman', '/c/smarta-las?brand=36301'],
    ['google chromecast', '/c/mediaspelare?brand=11752'],
    ['gopro', '/c/videokameror?brand=3681'],
    ['fitbit', '/c/aktivitetsarmband?brand=24328'],
  ])
);

export const getMapping = (
  market: MarketCodes,
  query: string
): string | undefined => {
  return mappings.get(market)?.get(query.toLowerCase().trim());
};
